module.exports = __webpack_public_path__ + "static/media/anti-corruption-plans-1st-half-of-2021.1511502d.pdf";